'use strict';

var constants = {
  PlayStates: {
    loaded: 'loaded',
    connecting: 'connecting',
    error: 'error',
    idle: 'idle',
    playing: 'playing',
    stopped: 'stopped',
    unplayable: 'unplayable'
  },
  Networks: {
    dfp: 'dfp',
    adswizz: 'adswizz',
    fallback: 'fallback'
  },
  LocalStorage: {
    PREROLL_LAST_PLAYED: 'PREROLL_LAST_PLAYED',
    AUDIENCES: 'LOTAME_LIGHTNING_AUDIENCES'
  },
  MediumTypes: {
    display: 'display',
    audio: 'audio',
    video: 'video'
  },
  SubscriptionStatus: {
    unknown: 'Unknown',
    none: 'None',
    active: 'Active',
    expired: 'Expired',
    temporarilyLocked: 'TemporarilyLocked',
    suspended: 'Suspended'
  }
};

module.exports = constants;